import { differenceInMilliseconds, isBefore, isSameDay } from 'date-fns';

import { ContractMessage } from '../../../../types/ContractMessage';
import { Tag } from '../../../cdl/Tag/Tag';
import { Tooltip } from '../../../cdl/Tooltip/Tooltip';
import { translate } from '../../../common/helpers/translate.helper';
import { MILLISECONDS_IN_DAY } from '../../../common/time.constants';

interface ContractTableExpirationDisplayProps {
    contract: ContractMessage;
}

export const ContractTableExpirationDisplay = ({ contract }: ContractTableExpirationDisplayProps) => {
    const now = new Date();

    if (
        contract.validFrom &&
        isBefore(now, new Date(contract.validFrom)) &&
        !isSameDay(now, new Date(contract.validFrom))
    ) {
        return contract.evergreen ? <Tag variant="default">{translate('contracts.labels.evergreen')}</Tag> : null;
    }

    if (!contract.validUntil) {
        return contract.evergreen ? <Tag variant="default">{translate('contracts.labels.evergreen')}</Tag> : null;
    }

    const daysUntilExpiration = Math.ceil(
        differenceInMilliseconds(new Date(contract.validUntil), now) / MILLISECONDS_IN_DAY
    );

    if (daysUntilExpiration <= 0) {
        return contract.evergreen ? <Tag variant="default">{translate('contracts.labels.evergreen')}</Tag> : null;
    }

    const expirationDaysLabel = translate('contracts.expiration.days', { count: String(daysUntilExpiration) });

    if (contract.evergreen) {
        return (
            <Tooltip label={expirationDaysLabel} showArrow side="top">
                <Tag variant="default">{translate('contracts.labels.evergreen')}</Tag>
            </Tooltip>
        );
    }

    return expirationDaysLabel;
};
